import Hls from 'hls.js';
import {VideoHlsBasePlayer} from './video-player-hls-base';

export class LiveStreamHlsPlayer extends VideoHlsBasePlayer {

    play() {
        if (this._hlsInstance) {
            this._hlsInstance.startLoad();
            super.play();
        } else {
            this._hlsInstance = this._createHlsInstance();
        }
    }

    pause() {
        super.pause();
        this._hlsInstance?.stopLoad();
    }

    private _createHlsInstance(): Hls {
        const hlsInstance = new Hls(this.HLS_CONFIG);

        hlsInstance.on(Hls.Events.ERROR, this._onHlsError);
        hlsInstance.on(Hls.Events.MEDIA_ATTACHED, this._onMediaAttached);
        hlsInstance.on(Hls.Events.LEVEL_UPDATED, this._onLevelUpdated);
        hlsInstance.on(Hls.Events.FPS_DROP, this._onFpsDrop);
        hlsInstance.on(Hls.Events.FRAG_LOADED, this._onBandwidthEstimate);
        hlsInstance.bandwidthEstimate =  this.services.videoOnDemandPlaying.bandwidthEstimate;

        hlsInstance.on(Hls.Events.MANIFEST_PARSED, this._onManifestParsed);

        hlsInstance.attachMedia(this.videoReference);

        return hlsInstance;
    }
}
